import * as React from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import ListNameLabel from 'flow-doctor-lib/components/common/ListNameLabel';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import { formatTimestampToPortalTz } from 'flow-doctor-lib/utils/dateTimeUtils';
import { getListUrl, getUserUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const BulkEnrollListAnalysisDetails = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  const enrolledByUserId = diagnosisReason.userId;
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: enrolledByUserId ? 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.BULK_ENROLL_LIST.withUser_jsx' : 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeDetail.BULK_ENROLL_LIST.withoutUser_jsx',
      elements: {
        ObjectNameLabel,
        ObjectTypeLabel,
        UserNameLabel,
        ListNameLabel,
        b: 'b',
        ViewLink: UILink
      },
      options: {
        listName: {
          portalId: selectedEnrollment.portalId,
          listId: diagnosisReason.listId,
          showId: getIsInternal()
        },
        objectName: {
          portalId: selectedEnrollment.portalId,
          objectTypeId: selectedEnrollment.objectTypeId,
          objectId: selectedEnrollment.objectId,
          showId: getIsInternal()
        },
        objectTypeLabel: {
          lowerCase: true,
          objectTypeId: selectedEnrollment.objectTypeId,
          portalId: selectedEnrollment.portalId,
          plural: true
        },
        viewUserLink: {
          external: true,
          href: enrolledByUserId ? getUserUrl({
            portalId: selectedEnrollment.portalId,
            userId: enrolledByUserId
          }) : undefined
        },
        viewListLink: {
          external: true,
          href: getListUrl({
            portalId: selectedEnrollment.portalId,
            listId: diagnosisReason.listId
          })
        },
        userId: enrolledByUserId,
        timestamp: formatTimestampToPortalTz(selectedEnrollment.timestamp)
      }
    })
  });
};
export default BulkEnrollListAnalysisDetails;